module.exports = __webpack_public_path__ + "img/client2.adfe7192.png";